import { FALLBACK_NODE_COLOR } from '../constants.js';
import type {
  SankeyLayoutLink,
  SankeyLayoutNode,
} from '../types/sankey-internal.js';
import { buildLinkGradient } from '../utils/build-link-gradient.js';

export function drawLinks(
  ctx: CanvasRenderingContext2D,
  links: SankeyLayoutLink[],
  nodeColors: Map<string, string>,
  linkOpacity: number,
): void {
  for (const link of links) {
    const source = link.source as SankeyLayoutNode;
    const target = link.target as SankeyLayoutNode;

    if (
      source.x0 === undefined ||
      source.x1 === undefined ||
      target.x0 === undefined ||
      target.x1 === undefined ||
      link.y0 === undefined ||
      link.y1 === undefined ||
      link.width === undefined
    ) {
      continue;
    }

    const sx = (source.x0 + source.x1) / 2;
    const tx = (target.x0 + target.x1) / 2;
    const halfW = link.width / 2;
    const midX = (sx + tx) / 2;

    const sourceColor = nodeColors.get(source.id) ?? FALLBACK_NODE_COLOR;
    const targetColor = nodeColors.get(target.id) ?? FALLBACK_NODE_COLOR;

    ctx.beginPath();
    ctx.moveTo(sx, link.y0 - halfW);
    ctx.bezierCurveTo(
      midX,
      link.y0 - halfW,
      midX,
      link.y1 - halfW,
      tx,
      link.y1 - halfW,
    );
    ctx.lineTo(tx, link.y1 + halfW);
    ctx.bezierCurveTo(
      midX,
      link.y1 + halfW,
      midX,
      link.y0 + halfW,
      sx,
      link.y0 + halfW,
    );
    ctx.closePath();

    ctx.fillStyle = buildLinkGradient(
      ctx,
      sx,
      tx,
      sourceColor,
      targetColor,
      linkOpacity,
    );
    ctx.fill();
  }
}
